<template>
  <div class="calendar-month">
    <!-- WEEKS DAYS TITLE START-->
    <div class="calendar-month__head">
      <div class="calendar-month__header-item_width">
        <span>#</span>
      </div>

      <div class="calendar-month__header">
        <div
          class="calendar-month__header-item"
          v-for="weekDay in month.weekdays"
          :key="weekDay.id"
        >
          <span>{{ weekDay }}</span>
        </div>
      </div>
    </div>
    <!-- WEEKS DAYS TITLE END-->

    <!-- WEEKS DAYS START-->
    <div class="calendar-month__body">
      <div class="calendar-month__weekDays">
        <div v-for="number in month.numberOfWeek" :key="number" class="calendar-month__weekDay">
          <span>{{ number }}</span>
        </div>
      </div>

      <div class="calendar-month__days">
        <div class="calendar-month__body-row" v-for="row in month.calendar" :key="row.id">
          <calendar-month-item
            class="calendar-month__body-item"
            v-for="day in row"
            :key="day.id"
            :day="day"
            :toDay="toDay"
            :view="view"
            :class="{
              disabled: !day.isInPrimaryMonth,
              current__day: day.date.getTime() === toDay.getTime(),
            }"
          />
        </div>

        <add-btn @onClick="toggleShowModalAdd" />
      </div>
    </div>
    <!-- WEEKS DAYS END-->

    <modal :show="showModal" :showBtn="true" @close="toggleModal" :dark="true" :outside="false">
      <transition name="showmodal">
        <orders-modal :large="true" />
      </transition>
    </modal>

    <!-- ADD A NEW ORDERS START -->
    <modal :show="showModalAdd" @close="toggleShowModalAdd" :dark="true" :outside="false">
      <transition name="showmodal">
        <request-add-modal v-if="showModalAdd" @close="toggleShowModalAdd" />
      </transition>
    </modal>
    <!-- ADD A NEW ORDERS END -->

    <snackbar
      v-if="snackbar.show"
      :message="$t('forms.snackbarMessage')"
      @reopen="reopen"
      @close="closeSnackbar"
    />
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import requestAddModal from '@/components/modals/requests/requestAddModal'
import calendarMonthItem from '@/components/calendars/month/calendarMonthItem'
import addBtn from '@/components/controls/addBtn'
import snackbar from '@/components/controls/snackbar'
import ordersModal from '@/components/modals/orders/ordersModal'

export default {
    props: {
        month: {
            required: true,
        },
        toDay: {
            required: true,
        },
        monthRequests: {
            required: false,
        },
        detailsDate: {
            required: false,
        },
        view: {
            required: true,
        },
    },
    components: {
        requestAddModal,
        calendarMonthItem,
        addBtn,
        snackbar,
        ordersModal,
    },
    data() {
        return {
            activeRequest: { calendar: true },
        }
    },
    computed: {
        ...mapGetters({
            showModalAdd: 'requests/showModalAdd',
            snackbar: 'orders/snackbar',

            showModal: 'orders/showModal',
        }),
    },
    methods: {
        ...mapMutations({
            toggleShowModalAdd: 'requests/toggleShowModalAdd',
            setSnackbarShow: 'orders/setSnackbarShow',
            setSnackbarData: 'orders/setSnackbarData',
            toggleModal: 'orders/setToggleModal',

            setToggleModalState: 'orders/setToggleModalState',
        }),
        ...mapActions({
            addApplication: 'addApplication',
            fetchById: 'orders/fetchById',
        }),
        async addNewRequest(data) {
            this.$Progress.start()
            await this.addApplication(data)

            this.toggleShowModalAdd()
            this.$Progress.finish()
        },
        async reopen() {
            const { id } = this.snackbar.data
            await this.fetchById(id)
            this.setToggleModalState(true)
            this.setSnackbarShow(false)
        },
        closeSnackbar() {
            this.setSnackbarShow(false)
        },
    },
    mounted() {
        this.setSnackbarShow(false)
    },
}
</script>
<style lang="scss">
@import "src/assets/sass/main";

.calendar-month {
  background-color: var(--bg-color);
  border-radius: 8px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16);
  width: 100%;
  box-sizing: border-box;
  color: var(--label-color);
  // margin-bottom: 36px;

  &__head {
    display: flex;
    width: 100%;
    border: 1px solid var(--border-color);
    border-bottom: unset;
    text-transform: uppercase;
  }

  &__header {
    display: flex;
    width: 100%;
    line-height: 14px;
    margin: 5px 0;

    &-item {
      flex-grow: 1;
      display: flex;
      justify-content: center;
      align-items: center;
      font-family: $fontMedium;
      color: var(--label-color);
      font-size: 11px;
      opacity: 0.5;
      text-align: center;
      width: 100%;

      &_width {
        width: 40px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-family: "SFUIDisplay-Medium";
        color: #4d4d4d;
        font-size: 16px;
        opacity: 0.5;
      }
    }
  }

  &__weekDays {
    width: 30px;
  }

  &__weekDay {
    width: 100%;
    height: 130px;
    display: flex;
    justify-content: center;
    padding-top: 12px;
    border: solid 1px var(--border-color);
    color: var(--label-color);
    box-sizing: border-box;
    font-size: 11px;
  }

  &__days {
    width: 100%;
  }

  &__body {
    display: flex;
    width: 100%;
    &-row {
      display: flex;
      align-items: stretch;
      border-collapse: collapse;
    }

    &-item {
      flex-grow: 1;
      width: 100%;
      height: 130px;
      background-color: var(--bg-color);
      border: solid 1px var(--border-color);
      padding: 9px 20px;
      box-sizing: border-box;
      // transition: 0.5s;
      overflow: hidden;
      cursor: pointer;
      position: relative;

      &:hover {
        // background-color: rgba(#71bd4a, 0.1);
        background: var(--hover-newbg-color);
      }

      & .calendar-row {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 18px;
      }

      & .day {
        font-size: 20px;
        font-family: $fontMedium;
        color: var(--menu-text-color);
      }

      & .notification {
        width: 24px;
        height: 24px;
        background-color: var(--bg-color-green);
        color: #ffffff;
        font-size: 12px;
        font-family: $fontMedium;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
      }

      // & .day {
      //   font-size: 20px;
      //   font-family: $fontMedium;
      //   // color: #4d4d4d;
      // }

      &.disabled {
        background-image: url("/images/icon/Calendar-placeholder.svg");
        background-size: cover;
        background-position: center;
        opacity: 0.1;
        z-index: 0;
      }

      &.current__day {
        background: var(--hover-newbg-color);
      }

      & .lines {
        display: flex;
        flex-direction: column;

        &__wrapper {
          display: flex;
          flex-direction: column;
        }
      }

      & .line {
        height: 1.5px;
        // background-color: #00d8ff;
        display: inline-block;
        width: 0;
        margin-bottom: 2.5px;
      }

      & .master {
        & .line {
          margin-bottom: 8px;
          height: 2px;
        }

        &__info {
          display: flex;
          align-items: center;

          &-image {
            width: 30px;
            height: 30px;
            border: solid 1px $secondColor;
            background-size: cover;
            background-position: center;
            border-radius: 50%;
            margin-right: 16px;
          }

          &-text {
          }

          &-name {
            color: #4d4d4d;
            font-size: 10px;
            font-family: $fontBold;
            margin-bottom: 2px;
          }

          &-time {
            color: #4d4d4d;
            font-size: 10px;
          }

          &.empty {
            opacity: 0.4;
          }
        }
      }
    }
  }
}

.notification-count {
  width: 24px;
  height: 24px;
  background-color: var(--bg-color-green);
  color: #ffffff;
  font-size: 12px;
  font-family: $fontMedium;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 12px;
}
</style>
